<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{ $t('Company') }}</h6>
                                <h1 class="header-title">{{ $t('Tasks') }}</h1>
                            </div>
                            <div class="col-auto">
                                <button @click="openModal({id:'TaskModal'})" class="btn btn-primary">{{ $t('Add') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Card -->
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col"></div>

                            <!-- status filter-->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            @click="statusQuery=[]"
                                            v-if="statusQuery.length>0"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Status')">
                                            <div
                                                v-for="(status, index ) in statusList"
                                                :key="index"
                                                class="dropdown-item pl-3"
                                            >
                                                <b-form-checkbox v-model="statusQuery" :value="index">
                                                    <b-badge pill :variant="status.variant">
                                                        <i class="fe" :class="status.icon"></i>
                                                    </b-badge>
                                                    {{ $t(status.label) }}
                                                </b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- date-filter -->
                            <div class="d-none d-xl-block col-auto">
                                <date-filter v-model="dates" :future="true" :initial="'today'"></date-filter>
                            </div>

                            <!-- team-filter -->
                            <div class="d-none d-xl-block col-auto" v-if="$hasPermission('tasks', ['seeAll'])">
                                <team-filter v-model="user"></team-filter>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'tasksListFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>

                <div class="card card-inactive" v-if="tasks.length == 0 && !areTasksLoading">
                    <div class="card-body text-center text-muted small">
                        <div class="row justify-content-center">
                            <div class="col-12 mt-5">
                                <div class="d-flex justify-content-center">
                                    <img
                                        src="@/assets/img/illustrations/32desk/tasks.svg"
                                        class="img-fluid mt-n5"
                                        style="max-height: 400px;"
                                    />
                                </div>
                                <p class="text-muted mb-4">{{ $t('Nothing yet') }}</p>
                            </div>
                            <div class="col-12">
                                <button
                                    @click="openModal({id:'TaskModal'})"
                                    class="btn btn-primary"
                                >{{ $t('Add') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <tasks-list-component :tasks="tasks" :loading="areTasksLoading" :openAppointmentModal="openAppointmentModal"></tasks-list-component>

                <task-modal id="TaskModal"></task-modal>
            </div>
        </div>

        <mobile-filters-modal id="tasksListFilterModal">
            <!-- status filter-->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            @click="statusQuery=[]"
                            v-if="statusQuery.length>0"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Status')">
                            <div
                                v-for="(status, index ) in statusList"
                                :key="index"
                                class="dropdown-item pl-3"
                            >
                                <b-form-checkbox v-model="statusQuery" :value="index">
                                    <b-badge pill :variant="status.variant">
                                        <i class="fe" :class="status.icon"></i>
                                    </b-badge>
                                    {{$t(status.label) }}
                                </b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>

            <!-- date-filter -->
            <div class="col-12 mb-3">
                <date-filter v-model="dates" :future="true" :initial="'today'"></date-filter>
            </div>

            <!-- team-filter -->
            <div class="col-12 mb-3" v-if="$hasPermission('tasks', ['seeAll'])">
                <team-filter v-model="user"></team-filter>
            </div>
        </mobile-filters-modal>

    </div>
</template>

<script>

import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import TeamFilter from "@/components/TeamFilter";
import DateFilter from "@/components/DateFilter";
import User from "@/components/User";
import StatusBadge from "./StatusBadge";
import TaskModal from "./TaskModal";
import { statusList } from '@/filters/task-status.js';
import CustomerCard from "@/components/CustomerCard";
import ConfirmableButton from '@/components/ConfirmableButton';
import mobileFiltersModal from "@/components/mobileFiltersModal";
import TasksListComponent from '@/components/Tasks/TasksListComponent.vue';

    export default {
        mixins: [modalMixins],
        components: {
            CustomerCard,
            TaskModal,
            StatusBadge,
            User,
            DateFilter,
            TeamFilter,
            ConfirmableButton,
            mobileFiltersModal,
            TasksListComponent,
        },
        data() {
            return {
            currentTask: 0,
            modalName: 'TaskViewModal',
            statusQuery: ['started', 'new', 'cancelled'],
            user: [],
            dates: {},
            model: {},
            errors: {},
        };
    },
    computed: {
        ...mapGetters('tasks', { findTasksInStore: 'find' }),
        ...mapState('tasks', { areTasksLoading: 'isFindPending' }),

        tasks() {
            return this.findTasksInStore(this.params).data;
        },

        statusList() {
            return statusList;
        },

        params() {
            const params = {
                query: {
                    $sort: { 'startDate': 1 }
                }
            };
            if (this.statusQuery.length)
                params.query.status = { $in: this.statusQuery };

            if (this.user.length)
                params.query['upcoming.userId'] = { $in: this.user };

            if (this.dates.start)
                params.query.startDate = { $lte: this.dates.end, $gte: this.dates.start };

            return params;
        },
    },
    watch: {
        params() {
            this.findItems();
        },
    },
    methods: {
        ...mapActions('tasks', ['find', 'patch']),

        openPatientPage(customerId) {
            this.$router.push({ name: 'people.customer', params: { id: customerId } })
        },

        openAppointmentModal(task) {
            let data = {};
            if (task.customerId) {
                data.customerId = task.customerId;
            }
            if (task.upcoming) {
                data.startAt = task.startDate;
                data.services = task.upcoming.map(el => ({
                    user: el.userId,
                    treatment: el.treatment,
                    duration: el.treatment ? el.treatment.duration : 0,
                    quantity: 1,
                }))
            }
            this.openModal({ id: 'AppointmentFastModal', model: {}});
            const { Appointment } = this.$FeathersVuex;


            new Appointment({
                model: data,
                _id: 'temp'
            });
        },


        setStatus(task, status) {

            this.patch([task._id, { status: status }]);
            this.currentTask = 0;
        },

        findItems() {
            this.find(this.params);
        },

        view(item) {
            const { Task } = this.$FeathersVuex;
            new Task({ model: item, _id: 'temp' });
            this.openModal({
                id: 'TaskViewModal',
                model: item
            })
        },
    }
}
</script>
<style>
.customer-card:hover {
    color: #2C7BE5
}
</style>
